(function () {
  'use strict';

  function getGrid() { return document.getElementById('product-grid'); }
  function getMoreBtn() { return document.querySelector('.infinite-scroll__more-button'); }
  function getMoreWrap() { return document.querySelector('.infinite-scroll__more'); }

  var state = { grid: null, nextUrl: null, loading: false, done: false };

  // Read the "next page" URL from Dawn's pagination, then hide the numbered nav.
  // NOTE: in Dawn the *next* arrow uses class `pagination__item--prev` (inverted, but stable).
  function readNextUrl(root) {
    root = root || document;
    var wrapper = root.querySelector('.pagination-wrapper');
    if (!wrapper) return null;
    var nextLink = wrapper.querySelector('a.pagination__item--prev[href]');
    var url = nextLink ? nextLink.getAttribute('href') : null;
    wrapper.style.display = 'none'; // JS takes over; keep it in DOM as a fallback
    return url;
  }

  // Show the "See more" button only while there are more pages to load.
  function updateButton() {
    var wrap = getMoreWrap();
    if (!wrap) return;
    wrap.style.display = (state.done || !state.nextUrl) ? 'none' : '';
  }

  async function loadNext() {
    if (state.loading || state.done || !state.nextUrl) return;
    var grid = getGrid();
    if (!grid) return;
    state.loading = true;
    var btn = getMoreBtn();
    if (btn) btn.disabled = true;
    try {
      var res = await fetch(state.nextUrl);
      if (!res.ok) throw new Error('pagination fetch ' + res.status);
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var newGrid = doc.getElementById('product-grid');
      if (newGrid) {
        var frag = document.createDocumentFragment();
        newGrid.querySelectorAll('li.grid__item').forEach(function (li) {
          li.classList.remove('scroll-trigger', 'animate--slide-in'); // show immediately
          frag.appendChild(document.importNode(li, true));
        });
        grid.appendChild(frag);
      }
      state.nextUrl = readNextUrl(doc); // next page's next-link, or null when done
      if (!state.nextUrl) state.done = true;
    } catch (e) {
      console.warn('[infinite-scroll]', e);
      var w = document.querySelector('.pagination-wrapper');
      if (w) w.style.display = ''; // restore normal pagination on failure
      state.done = true;
    } finally {
      state.loading = false;
      var b = getMoreBtn();
      if (b) b.disabled = false;
      updateButton();
      requestAnimationFrame(maybeLoad); // keep filling if still near the bottom
    }
  }

  function nearBottom() {
    return (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 800);
  }

  var ticking = false;
  function maybeLoad() {
    ticking = false;
    if (!state.done && !state.loading && state.nextUrl && nearBottom()) loadNext();
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(maybeLoad); }
  }

  function wireButton() {
    var btn = getMoreBtn();
    if (btn && !btn.dataset.wired) {
      btn.dataset.wired = '1';
      btn.addEventListener('click', function (e) { e.preventDefault(); loadNext(); });
    }
  }

  function init() {
    var grid = getGrid();
    if (!grid) return;
    state.grid = grid;
    state.done = false;
    state.loading = false;
    state.nextUrl = readNextUrl(document);
    wireButton();
    updateButton();
    if (!state.nextUrl) { state.done = true; return; } // single page, nothing to do
    requestAnimationFrame(maybeLoad); // initial check in case the page is short
  }

  function boot() {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    init();
    // Re-init when vertical filters/sort swap out the grid.
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(function () {
        var g = getGrid();
        if (g && g !== state.grid) init();
      }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
